import { LicenseType } from '@/core/api/collections/users';
import { LicensesRemaining } from '@/core/auth/AuthContext';

export type UserEditField = 'licenseType';
export enum UserEditError {
  NO_LICENSES_ADMIN = 'You do not have enough Admin licenses remaining',
  NO_LICENSES_CONTRIBUTOR = 'You do not have enough Contributor licenses remaining',
  NO_LICENSES_SUPPORT = 'You do not have enough Support licenses remaining',
}
export type UserEditValidationErrors = {
  [key in UserEditField]?: UserEditError;
}

export const validateLicenseType = (licenseType: LicenseType, licensesRemaining: LicensesRemaining, licensesRequested = 1) => {
  if (licenseType === 'fullaccess_admin' && licensesRemaining?.admin < licensesRequested) {
    return UserEditError.NO_LICENSES_ADMIN;
  } else if (licenseType === 'contributor' && licensesRemaining?.contributor < licensesRequested) {
    return UserEditError.NO_LICENSES_CONTRIBUTOR;
  } else if (licenseType === 'helpdesk_admin' && licensesRemaining?.support < licensesRequested) {
    return UserEditError.NO_LICENSES_SUPPORT;
  }
};
